import React from 'react';
import {  Route, Switch} from 'react-router';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { blue, red } from '@material-ui/core/colors/blue';
import Login from './Pages/Login';
import Dashboard from './Dashboard';
// import App from '../App';
const Admin = () =>{
    const theme = createMuiTheme({
        palette: {
          primary:blue,
          secondary:red,
        },
      });

    return(
        <>
        <ThemeProvider theme={theme}>
        
        <Switch>
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/login" component={Login} />
        </Switch>
        
        </ThemeProvider>
        {/* <App/> */}
        </>
    );
};
export default Admin;